import { isFRQ, isMCQ } from '../progressHelpers';

/**
 * @param {*} { questions, isPracticeExam }
 * @param {boolean} [hasAudioRecordOrFileUpload=false]
 * @returns boolean
 * This function checks if the combination of the array of questions
 * meets the conditions below
 */
const shouldTurnOnSecureAssessment = (
  { questions = [], isPracticeExam },
  hasAudioRecordOrFileUpload = false,
) => {
  let status = false;

  if (hasAudioRecordOrFileUpload) {
    return false;
  }

  // The reason why "every" is used here instead of "foreach" is to break
  // out of the loop when a falsy value is found.
  questions.every((question) => {
    if (isMCQ(question) && isPracticeExam) {
      // it handles PE (MCQ)
      status = true;
    } else if (isMCQ(question)) {
      // it handles QB with secure/not-secure (MCQ)
      status = true;
    } else status = !!(isFRQ(question) && !isPracticeExam);
    return status;
  });

  return status;
};

export default shouldTurnOnSecureAssessment;
